export default "__VITE_ASSET__WhWJZXZ5__"